<template>
    <div style="float: right;margin-top: 10px;">
        <div style="display: flex;">
            <el-avatar :size='avatarSize' :src='avatarURL' style="margin-top: 6px;"></el-avatar>
            <div style="margin-left: 10px;height: 40px;line-height: 40px;vertical-align: middle;color: white">{{ userName }}</div>
            <el-button style="margin-left: 20px;"  @click="logout" type="text">退出登录</el-button>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import screenfull from 'screenfull';
export default {
  data () {
    return {
      avatarSize: 'small',
      avatarURL: require('../../assets/images/avatar.png'),
      account: storageKit.get(jsCtx.localConstant.account),
      userName: JSON.parse(storageKit.get(jsCtx.localConstant.userInfo)).name
    };
  },
  computed: {
    ...mapState(['User']),
    siderCollapsed: {
      get() {
        return this.$store.state.siderCollapsed;
      },
      set(value) {
        this.$store.commit('updateSiderCollapse', value);
      }
    }
  },
  mounted () {
    this.initWindow();
  },
  methods: {
    initWindow() {
      const resizeEvent = window.addEventListener('resize', () => {
        if (this.siderCollapsed && window.innerWidth > 900) {
          this.siderCollapsed = false;
        } else if (!this.siderCollapsed && window.innerWidth < 900) {
          this.siderCollapsed = true;
        }
      });
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', resizeEvent);
      });
      window.dispatchEvent(new Event('resize'));
    },
    logout() {
      this.$confirm('此操作将退出系统，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        storageKit.remove(jsCtx.localConstant.token);
        storageKit.remove(jsCtx.localConstant.tabs);
        this.$router.replace({ name: 'Login' });
      }).catch(() => {
        this.$message.warning('已取消退出');
      });
    },
    goPassword() {
      this.$router.push({ path: '/password' });
    },
    showSettingModal() {
      this.$emit('openSetting');
    },
    // 全屏显示
    fullScreen() {
      if (!screenfull.enabled) {
        return false;
      }
      screenfull.toggle();
    }
  }
};
</script>
<style lang="less">
    ._header {
        color: #555;
        height: 50px;
        &-btn{
            float: left;
            width: 50px;
            i {
                font-size: 26px;
            }
        }
        &-info{
            margin-right: 20px;
        }
        &-info &-icon-item {
            cursor: pointer;
            display: inline-block;
            float: left;
            padding: 0 15px;
            height: 50px;
            line-height:50px;
            &:hover {
                background: 50px;
            }
            i {
                font-size: 18px;
            }
            a {
                color: inherit;
            }
            .h-badge {
                margin: 20px 0;
                display: block;
            }
        }
        &-menus{
            display: inline-block;
            vertical-align: top;
            >div {
                display: inline-block;
                font-size: 15px;
                padding: 0 25px;
                //color: @dark-color;
                &:hover{
                    //background: @hover-background-color;
                }
                +div {
                    margin-left: 5px;
                }
                &.h-tab-selected{
                    //color: @white-color;
                    //background-color: @primary-color;
                }
            }
        }
    }
</style>
